"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = require("react");
var _componentUtils = require("@active/react-utils/componentUtils");
var _isEmpty = _interopRequireDefault(require("lodash/fp/isEmpty"));
var _includes = _interopRequireDefault(require("lodash/fp/includes"));
var _DropdownPresenter2 = _interopRequireDefault(require("./DropdownPresenter"));
var _MultiSelectionPresenter = _interopRequireDefault(require("./MultiSelectionPresenter"));
var _TagDropdownButton = _interopRequireDefault(require("./TagDropdownButton"));
var _MenuItemList = _interopRequireDefault(require("../MenuItemList"));
var _MenuHeader = _interopRequireDefault(require("../MenuHeader"));
var _MenuFooter = _interopRequireDefault(require("../MenuFooter"));
var _MenuEmpty = _interopRequireDefault(require("../MenuEmpty"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var TaggedPresenter = exports["default"] = /*#__PURE__*/function (_DropdownPresenter) {
  function TaggedPresenter(i18n, omitSelectedOption, suppressInnerEmptyMenu) {
    var _this;
    (0, _classCallCheck2["default"])(this, TaggedPresenter);
    _this = _callSuper(this, TaggedPresenter, [i18n, omitSelectedOption, suppressInnerEmptyMenu]);
    _this.multipleSelectionPresenter = new _MultiSelectionPresenter["default"](i18n, omitSelectedOption);
    return _this;
  }
  (0, _inherits2["default"])(TaggedPresenter, _DropdownPresenter);
  return (0, _createClass2["default"])(TaggedPresenter, [{
    key: "DropdownButton",
    get: function get() {
      return _TagDropdownButton["default"];
    }
  }, {
    key: "emitValue",
    value: function emitValue(valueSelected, prevValue, children) {
      return this.multipleSelectionPresenter.emitValue(valueSelected, prevValue, children);
    }
  }, {
    key: "renderOptionList",
    value: function renderOptionList(menuItemList, value) {
      var _menuItemList$props;
      var children = (0, _componentUtils.filterChildren)(function (option) {
        var _option$props;
        return !(0, _includes["default"])(option === null || option === void 0 || (_option$props = option.props) === null || _option$props === void 0 ? void 0 : _option$props.value)(value);
      })(menuItemList === null || menuItemList === void 0 || (_menuItemList$props = menuItemList.props) === null || _menuItemList$props === void 0 ? void 0 : _menuItemList$props.children);
      return (0, _isEmpty["default"])(children) && !this.suppressInnerEmptyMenu ? /*#__PURE__*/(0, _react.createElement)(_MenuEmpty["default"], {}, this.i18n('react-ui.common.dropdown.label.tag.no.option.left')) : /*#__PURE__*/(0, _react.cloneElement)(menuItemList, {
        children: children
      });
    }
  }, {
    key: "renderChildren",
    value: function renderChildren(value, children) {
      var _this2 = this;
      if (!this.omitSelectedOption) {
        return children;
      }
      return _react.Children.map(children, function (child) {
        var _child$props, _child$props2;
        switch ((0, _componentUtils.typeOf)(child)) {
          case _MenuHeader["default"].displayName:
          case _MenuFooter["default"].displayName:
            return child;
          case _MenuItemList["default"].displayName:
            return _this2.renderOptionList(child, value);
          default:
            return child !== null && child !== void 0 && (_child$props = child.props) !== null && _child$props !== void 0 && _child$props.children ? /*#__PURE__*/(0, _react.cloneElement)(child, {
              children: _this2.renderChildren(value, child === null || child === void 0 || (_child$props2 = child.props) === null || _child$props2 === void 0 ? void 0 : _child$props2.children)
            }) : child;
        }
      });
    }
  }, {
    key: "isItemSelected",
    value: function isItemSelected(itemValue, value) {
      var _value$indexOf;
      return this.omitSelectedOption ? false : ((_value$indexOf = value === null || value === void 0 ? void 0 : value.indexOf(itemValue)) !== null && _value$indexOf !== void 0 ? _value$indexOf : -1) >= 0;
    }
  }, {
    key: "menuCollapseBehavior",
    get: function get() {
      return this.multipleSelectionPresenter.menuCollapseBehavior;
    }
  }, {
    key: "renderDefaultLabel",
    value: function renderDefaultLabel(value, children) {
      return this.multipleSelectionPresenter.renderDefaultLabel(value, children);
    }
  }]);
}(_DropdownPresenter2["default"]);